// extracted by mini-css-extract-plugin
module.exports = {"popup":"boxDownload_popup_1Fn4x","content":"boxDownload_content_3bvog"};